export class Level {

  constructor() {
  }

  buildModel() {
  }

  /*
   * Get a attribute by name.
   * Accepts dimension level in the input string.
   */
  getAttribute(attribute) {

    let attr = $.grep(this.attributes, function (el) {
      return el.name == attribute;
    })[0];

    return attr;
  }

  /*
   * Processes a cell and returns an object with a stable information:
   * o.key
   * o.label
   * o.info[]
   */
  readCell(cell) {

    if (!(this.getAttribute(this.key).full_name in cell)) return null;

    let result = {};
    result.key = cell[this.getAttribute(this.key).full_name];
    result.label = cell[this.getAttribute(this.label_attribute).full_name];
    result.info = {};
    this.attributes.forEach((attribute) => {
      result.info[attribute.name] = cell[attribute.full_name];
    });
    return result;
  }

  toString() {
    return this.dimension.toString().split(':')[0] + ':' + this.name;
  }

}



// WEBPACK FOOTER //
// ./src/common/level.js